import { ContentService } from '@blk/cwp-ng-framework';
import { ClientOutput } from '@ddt-web/domain';
import { Replacer } from '@ddt-web/rules-engine';
import * as dayjs from 'dayjs';

import { SvgSanitizer } from './svg-sanitizer';

export class ReportCoverResolver {
	/**
	 * Substitutes report metadata into an SVG cover template. Every value is XML-encoded first so
	 * user-controlled metadata can only ever become text, never SVG structure (CWE-79).
	 */
	public static resolve(reportCover: string, clientOutput: ClientOutput, contentService: ContentService, tagDelimiter: string): string {
		const contentReplacer = new Replacer({});
		clientOutput['date'] = dayjs().format('MMMM D, YYYY');
		if (!clientOutput['advisorLogo']) {
			clientOutput['advisorLogo'] = '';
		}
		const substitutionMap: Object = new Object();
		contentReplacer.populateDCRTags(reportCover, substitutionMap, contentService);
		const escapedClientOutput = SvgSanitizer.escapeSubstitutionValues(clientOutput, ['advisorLogo']);
		return contentReplacer.resolveDataValues(reportCover, { ...escapedClientOutput, ...substitutionMap }, contentReplacer.TAG_REGEX, tagDelimiter);
	}
}
